import { FC, useEffect } from "react";
import { XmSpinner } from "src/component/spinner/XmSpinner";
import { useUiPrefsStore } from "src/store/useUiPrefsStore";
import { GLOB } from "src/util/Glob";
import { resetAllUserManagementStores } from "../configuration/userManagement/store/resetAllUserManagementStores";

export const Logout: FC = () => {

  useEffect(() => {
    GLOB.authService.logOut();
    resetAllUserManagementStores();
    useUiPrefsStore.getState().reset();
  }, []);

  return <XmSpinner />;
}